import constants from "../../constants/index.js";

const { OS_NAME } = constants;
const DEFAULT_TITLE = "Moj - Indian app";
const DEFAULT_DESC =
  "Watch and create short videos, like 16 crore Indians on Moj.";
const uniqueVideoCounts = "uniqueVideoCounts";
const appStoreImg = "/assets/png/app-store-badge.png";
const appStoreImg2x = "/assets/png/app-store-badge@2x.png";
const playStoreImg = "/assets/png/google-play-badge.png";
const playStoreImg2x = "/assets/png/google-play-badge@2x.png";
/**
 *
 * @returns {Boolean}
 */
export const isBrowser = () =>
  typeof window !== "undefined" &&
  !!window.document &&
  !!window.document.createElement;

export const DEFAULT_META_DATA = {
  title: DEFAULT_TITLE,
  description: DEFAULT_DESC,
  og_tags: [
    { p: "og:title", c: DEFAULT_TITLE },
    { p: "og:description", c: DEFAULT_DESC },
    { p: "og:image", c: "/assets/icons/Logo_512.png" },
  ],
  mid_sections: [
    {
      img: "/assets/png/short-video-app/Moj_Playstore_Screens2.png",
      bgc: "#FF9B00",
      bgc2: "#000000",
      color: "#FFFFFF",
      title: "India’s most popular short videos app",
      desc: "Your awesomeness deserves the best. Take your expressions to the world, just like the millions on Moj. Join India’s most-popular short video app!",
      dir: true,
    },
    {
      img: "/assets/png/short-video-app/Moj_Playstore_Screens3.png",
      bgc: "#0090FF",
      bgc2: "#FFFFFF",
      color: "#000000",
      title: "Every act is loved here.",
      desc: "Sing with your bestie, dance with your family, do a duet with a Mojer! Your expressions have no limit, just like Moj.",
      dir: false,
    },
    {
      img: "/assets/png/short-video-app/Moj_Playstore_Screens.png",
      bgc: "#3BC94B",
      bgc2: "#000000",
      color: "#FFFFFF",
      title: "Moj filters to seize moments",
      desc: "Express in style and take the notch higher with the swashbuckling Moj camera filters.",
      dir: true,
    },
  ],
  qr_code_src: "/assets/png/Moj_QR.png",
  qr_code_2x_src: "/assets/png/Moj_QR@2x.png",
  qr_code_dark_src: "/assets/png/Moj_QR_dark.png",
  qr_code_dark_2x_src: "/assets/png/Moj_QR_dark@2x.png",
  top_play_store_link: "https://links.mojapp.in/p9tW/6f954cfb",
  bottom_play_store_link: "https://links.mojapp.in/p9tW/eda71714",
  footer_links: [
    {
      text: "Privacy Policy",
      href: "https://help.mojapp.in/policies/privacy-policy",
      id: "PRIVACY_POLICY",
    },
    {
      text: "Terms of Service",
      href: "https://help.mojapp.in/policies/terms",
      id: "TERMS_OF_SERVICE",
    },
    // {
    //   text: "Press",
    //   href: "#",
    // },
    // {
    //   text: "FAQ",
    //   href: "#",
    // },
    // {
    //   text: "Guidelines",
    //   href: "#",
    // },
  ],
  footer_media_links: [
    {
      href: "https://www.facebook.com/MojIndia/",
      img: "/assets/svg/ic_facebook_color_24.svg",
      img_hover: "/assets/svg/facebook_color.svg",
      alt: "Facebook",
    },
    {
      href: "https://www.instagram.com/mojindia/",
      img: "/assets/svg/ic_insta_color_24.svg",
      img_hover: "/assets/svg/insta_color.svg",
      alt: "Instagram",
    },
    // {
    //   href: "#",
    //   img: "/assets/svg/ic_twitter_color_24.svg",
    //   img_hover: "/assets/svg/twitter_color.svg",
    //   alt: "Twitter",
    // },
    // {
    //   href: "#",
    //   img: "/assets/svg/ic_whatsapp_color_24.svg",
    //   img_hover: "/assets/svg/whatsapp_color.svg",
    //   alt: "Whatsapp",
    // },
  ],
  css: {
    allCenteredChild: "flex justify-center items-center",
    horCenteredChild: "flex justify-center",
    verCenteredChild: "flex items-center",
    fullCover: "absolute left-0 top-0 w-full h-full",
    bottomAlign: "absolute left-0 w-full bottom-0",
    topRightAlign: "absolute right-0 top-0",
    horCentered: "absolute top-0 left-1/2 -translate-x-1/2",
  },
  takatak_app_store_link:
    "https://apps.apple.com/in/app/mx-takatak/id1522698952",
  takatak_black_logo: "/assets/png/takatak-logo-black.png",
};

export const obsoleteRoutes = [
  "/next-punjabi-star",
  "/moj-shop*",
  "/shop-the-look",
  "/make-a-wish*",
  "/lite-migration",
];

const APP_NAME = "MOJ_PWA";
const TAKATAK_APP = "MOJ_TAKATAK";
const ANDROID_APP_ID = "in.mohalla.video";
const ANDROID_TAKATAK_APP_ID = "com.next.innovation.takatak";
/**
 *
 * @param {string} utm_medium
 * @param {string} utm_source
 * @param {string} utm_campaign
 * @param {string} extraParams
 * @returns {string}
 */
export const PLAY_STORE_LINK = (
  utm_medium = APP_NAME,
  utm_source = APP_NAME,
  utm_campaign = APP_NAME,
  extraParams = ""
) =>
  `https://play.google.com/store/apps/details?id=${ANDROID_APP_ID}&referrer=utm_source%3D${utm_source}%26utm_medium%3D${utm_medium}%26utm_campaign%3D${utm_campaign}${extraParams}`;
/**
 *
 * @param {string} utm_medium
 * @param {string} utm_source
 * @param {string} utm_campaign
 * @param {string} extraParams
 * @returns {string}
 */
const fallbackUrl = (utmSource, deviceId = "") =>
  `https://play.google.com/store/apps/details?id=${ANDROID_APP_ID}&referrer=utm_source%3D${utmSource}%26utm_medium%3D${APP_NAME}%26utm_campaign%3D${APP_NAME}_${deviceId}`;
export const ANDROID_APP_INTENT = (
  pathname = "",
  userId = "",
  deviceId = ""
) => {
  return `intent://mojapp.in${pathname}/#Intent;scheme=mojapp;package=${ANDROID_APP_ID};S.browser_fallback_url=${encodeURIComponent(
    fallbackUrl(pathname + userId, deviceId)
  )};end`;
};
export const PLAY_STORE_TAKATAK_LINK = (
  pathname = "/",
  userId,
  deviceId = ""
) =>
  `https://play.google.com/store/apps/details?id=${ANDROID_TAKATAK_APP_ID}&referrer=utm_source%3D${
    pathname + userId
  }%26utm_medium%3D${TAKATAK_APP}%26utm_campaign%3D${TAKATAK_APP}_${deviceId}`;
/**
 *
 * @param {string} url
 * @param {string} fallback
 * @returns {string}
 */

export const MOJ_DEEP_LINK = (url, fallback) =>
  `intent://mojapp.in${
    url || ""
  }/#Intent;scheme=mojapp;package=${ANDROID_APP_ID};S.browser_fallback_url=${encodeURIComponent(
    fallback || "/"
  )};end`;
/**
 *
 * @param {string} url
 * @param {string} fallback
 * @returns {string}
 */
export const TAKATAK_DEEP_LINK = (url, deviceId = "") =>
  `intent://mojapp.in${
    url || ""
  }/#Intent;scheme=mojapp;package=${ANDROID_TAKATAK_APP_ID};S.browser_fallback_url=${encodeURIComponent(
    PLAY_STORE_TAKATAK_LINK(url, deviceId)
  )};end`;

export const PLAY_STORE_LINK_PREFIX = `https://links.mojapp.in/p9tW`;
export const TAKATAK_PLAY_STORE_LINK_PREFIX = `https://effect.mxtakatak.com/vQZT/0nvn9yd6`;

export const DEMO_CRED = {
  userId: 282852096,
  passCode: "513bd5843d7ad423cb8a",
};
/**
 *
 * @param {string} paramUa
 * @returns {object}
 */
export const uaData = (paramUa) => {
  if (typeof paramUa !== "string") return {};

  const ua = paramUa.toLowerCase();
  const bots = {
    google: ["googlebot", "google-structured", "adsbot"],
    social: ["whatsapp", "facebook", "facebot", "slackbot"],
    others: ["bingbot", "slurp", "duckduckbot"],
  };

  const is_google_bot =
    bots.google.filter((bot) => ua.indexOf(bot) !== -1).length > 0;
  const is_social_bot =
    bots.social.filter((bot) => ua.indexOf(bot) !== -1).length > 0;
  const is_other_bot =
    bots.others.filter((bot) => ua.indexOf(bot) !== -1).length > 0;
  const is_sharechat_bot = ua.indexOf("sharechat-android-bot") !== -1;
  const is_ios_webview = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
    ua
  );

  const is_bot =
    is_google_bot || is_social_bot || is_other_bot || is_sharechat_bot;
  return {
    is_bot,
    is_google_bot,
    is_social_bot,
    is_sharechat_bot,
    is_ios_webview,
  };
};
/**
 *
 * @param {object} post
 * @returns {string}
 */

export const getCaption = (post) => {
  if (!post) return "";
  const caption = (post.c || "").trim();
  if (caption) return caption;

  const arr = post.tt || [];
  const prefix = "#";
  return arr
    .map((el) => (typeof el !== "object" ? "" : prefix + el.n))
    .join(" ");
};

/**
 *
 * @param {object} post
 * @returns {string}
 */

export const getOgTitle = (post) => {
  if (!post) return "";

  const { l = "", lc = "", n = "" } = post;
  const views = parseInt(l) > 0 ? `${normalizeNumber(l)} Views` : "";
  const likes = parseInt(lc) > 0 ? `${normalizeNumber(lc)} Likes` : "";
  const name = `${n} on Moj`;
  return [views, likes, name].filter((item) => !!item).join(" | ");
};

/**
 *
 * @param {object} post
 * @returns {string}
 */

export const getOgDescription = (post) => {
  if (!post) return "";

  const { cd = "", s = "" } = post;
  const comments = parseInt(cd) > 0 ? `${normalizeNumber(cd)} Comments` : "";
  const shares = parseInt(s) > 0 ? `${normalizeNumber(s)} Shares` : "";
  const caption = getCaption(post) || getSongNameFromPost(post);
  return [comments, shares, caption].filter((item) => !!item).join(" | ");
};

/**
 *
 * @param {object} post
 * @returns {string}
 */

export const getPlayThumbnail = (post) => {
  if (!post) return "";
  return post.thumbWithOverlay || post.b;
};

/**
 *
 * @param {object} post
 * @returns {string}
 */

export const getSongNameFromPost = (post) => {
  return post?.audioMeta
    ? `${post.audioMeta.audioName} - ${post.audioMeta.audioText}`
    : "";
};

/**
 *
 * @param {string} paramnAgt
 * @returns {string}
 */
export const getOsName = (paramnAgt) => {
  const nAgt = paramnAgt || "";
  if (/windows phone|windows nt/i.test(nAgt)) {
    return OS_NAME.WINDOWS;
  }

  if (/android/i.test(nAgt)) {
    return OS_NAME.ANDROID;
  }

  if (/iPad|iPhone|iPod/i.test(nAgt)) {
    return OS_NAME.IOS;
  }

  if (/linux/i.test(nAgt)) {
    return OS_NAME.LINUX;
  }

  if (/mac/i.test(nAgt)) {
    return OS_NAME.OSX;
  }

  return "unknown";
};
/**
 *
 * @returns {Boolean}
 */
export const isAndroid = () =>
  isBrowser() && getOsName(navigator.userAgent) === "android";
/**
 *
 * @returns {Boolean}
 */
export const isIos = () =>
  isBrowser() && getOsName(navigator.userAgent) === "ios";
/**
 *
 * @returns {Boolean}
 */
export const isAppleDevice = () =>
  isBrowser() &&
  [OS_NAME.IOS, OS_NAME.OSX].includes(getOsName(navigator?.userAgent));

/**
 * rounds of a number
 * @param {Number} n
 * @returns {Number}
 */
const __getRounded = (n) => Math.round(n * 10) / 10;

export const isMobile = () => isAndroid() || isIos();
/**
 *
 * @param {String | Number} num
 * @param {Boolean} isInt
 * @returns {Number}
 */
export const normalizeNumber = (num, isInt) => {
  if (Number.isNaN(parseInt(num))) return 0;
  const useFunc = isInt ? Math.floor : __getRounded;
  if (num >= 1000000) return `${useFunc(num / 1000000)}M`;
  if (num >= 1000) return `${useFunc(num / 1000)}K`;
  return num;
};
/**
 *
 * @param {string} hostname
 * @returns {boolean}
 */
export const isTakatakDomain = (hostname) =>
  hostname && hostname.includes("takatak");

export const isIosWebview = () => {
  if (!window) return false;
  return /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
    window.navigator.userAgent
  );
};

export const isAndroidWebview = () => !!window.Android;

export const isAppView = () => {
  const is_ios_app_webview = isIosWebview();
  const is_android_app_webview = isAndroidWebview();
  const isAnyAppView = !!(is_ios_app_webview || is_android_app_webview);

  return isAnyAppView;
};

// reference https://stackoverflow.com/questions/5717093/check-if-a-javascript-string-is-a-url
export const isValidUrl = (url) => {
  const pattern = new RegExp(
    "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$",
    "i"
  ); // fragment locator
  return !!pattern.test(url);
};

export const getAppData = (key) => {
  const androidBridge = window.Android || window.ANDROID;
  return androidBridge?.get(key);
};

export const getPackageNameFromId = (id) => {
  const packages = {
    1: "com.phonepe.app",
    2: "com.google.android.apps.nbu.paisa.user",
    3: "net.one97.paytm",
    4: "in.amazon.mShop.android.shopping",
    5: "com.dreamplug.androidapp",
    6: "com.YesBank",
    7: "com.axis.mobile",
    8: "com.snapwork.hdfc",
  };
  return packages[id];
};

export const numberWithCommas = (i) => {
  const [before, afterDecimal] = i.toString().split(".");

  const x = before;
  let lastThree = x.substring(x.length - 3);
  const otherNumbers = x.substring(0, x.length - 3);
  if (otherNumbers !== "") lastThree = `,${lastThree}`;
  const no = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
  return afterDecimal ? `${no}.${afterDecimal}` : no;
};

export const _sanitizeInput = (str, expression = /[?;:<>{}[\]\\/]/gi) =>
  str ? str.replace(expression, "") : str;

export const sanitizeData = (values) => {
  const sanitizedValues = { ...values };
  Object.keys(sanitizedValues).forEach((key) => {
    if (typeof sanitizedValues[key] === "string") {
      sanitizedValues[key] = _sanitizeInput(sanitizedValues[key]);
    }
  });
  return sanitizedValues;
};

export const isStringNumeric = (str) => /^\d+$/.test(str);

export function getRedirectionUrl(location, deviceId = "") {
  let isTTDomain = isTakatakDomain(location?.host);
  const redirectLink = location?.pathname + location?.search;
  let deepLinkURL = isTTDomain
    ? TAKATAK_DEEP_LINK(redirectLink, deviceId)
    : ANDROID_APP_INTENT(redirectLink, deviceId);
  const redirectedUrl = `/redirect?to=${deepLinkURL}&from=${location?.href}`;
  return redirectedUrl;
}

export const extractRedirectUrl = (url = "", string = "to=") => {
  const startIndex = url.indexOf(string) + string.length; // added string.length to skip 'to='
  return url.substring(startIndex);
};

export const setLocalStorageWithExpiration = (key, value, expirationTime) => {
  const currentTimeStamp = Date.now();
  const expirationTimestamp = currentTimeStamp + expirationTime;

  isBrowser() &&
    localStorage.setItem(
      key,
      JSON.stringify({
        value,
        expiration: expirationTimestamp,
      })
    );
};

export const getLocalStorageWithExpiration = (key) => {
  const item = JSON.parse(isBrowser() && localStorage.getItem(key));

  if (item && item.expiration) {
    const currentTimeStamp = Date.now();
    if (currentTimeStamp < item.expiration) {
      return item.value;
    } else {
      isBrowser() && localStorage.removeItem(key);
      return null;
    }
  }

  return null;
};

export function createLocalStorageWithExpiration(
  key,
  value,
  expirationHour = 0, // Midnight is 0 Hrs
  expirationMinute = 0 // Midnight is 0 Mints
) {
  // Calculate the time until the specified expiration time today
  const currentTimeStamp = new Date();
  const expirationTimeToday = new Date(currentTimeStamp);
  expirationTimeToday.setHours(expirationHour, expirationMinute, 0, 0);

  let timeUntilExpiration = expirationTimeToday - currentTimeStamp;

  // If the specified time has already passed today, set it for the same time tomorrow
  if (timeUntilExpiration <= 0) {
    const midnightTomorrow = new Date(currentTimeStamp);
    midnightTomorrow.setDate(currentTimeStamp.getDate() + 1);
    midnightTomorrow.setHours(expirationHour, expirationMinute, 0, 0);
    timeUntilExpiration = midnightTomorrow - currentTimeStamp;
  }

  // Set the local storage item with the calculated expiration time
  setLocalStorageWithExpiration(key, value, timeUntilExpiration);
}

export const updateCachedObjectWithId = (id) => {
  // Retrieve the current cachedObject from localStorage
  const cachedObjectJSON = getLocalStorageWithExpiration(uniqueVideoCounts);
  let cachedObject = cachedObjectJSON ? JSON.parse(cachedObjectJSON) : {};

  // Initialize a Set to track unique IDs
  let uniqueIds = new Set(Object.keys(cachedObject));
  let uniqueCount = uniqueIds.size - 1;

  // If the ID is not in the cachedObject, add it and initialize the count to 1
  if (!cachedObject[id] && id) {
    cachedObject[id] = 1;
    uniqueIds.add(id);
    uniqueCount++;
  }

  let cachedValue = { ...cachedObject, uniqueCount };

  // Save the updated cachedObject back to localStorage
  createLocalStorageWithExpiration(
    uniqueVideoCounts,
    JSON.stringify(cachedValue)
  );
};

export const getInstallImage = () => {
  if (isAppleDevice())
    return {
      src: appStoreImg,
      srcSet: `${appStoreImg} 1x, ${appStoreImg2x} 2x`,
    };
  return {
    src: playStoreImg,
    srcSet: `${playStoreImg} 1x, ${playStoreImg2x} 2x`,
  };
};

export const isWebView = () => {
  return typeof window !== "undefined" && (window.Android || window.webkit);
};
